import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdbreact";
import axios from "axios";
import { mua } from "../../config/api";
import { isNurseRound } from "../../config/admissionRound";

import Select from "react-select";
import MetaTags from "react-meta-tags";
import Swal from "sweetalert2";
import { Text } from "evergreen-ui";

export default class Checkvutregister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      level: "",
      plan: "",
      vga: "",
      level2: "",
      plan2: "",
      vga2: "",
      array_level: [],
      array_plan: [],
      array_plan2: [],
    };

    this.handleLevelChange = this.handleLevelChange.bind(this);
    this.handlePlanChange = this.handlePlanChange.bind(this);
    this.handleVgaChange = this.handleVgaChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (localStorage.getItem("typestudent") === "3") {
      this.setState({ level: "5" });
      let headers = new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      });
      axios
        .post(
          mua + "/admission/plan/",
          { level: "5" },
          { headers: headers }
        )
        .then((plan) => {
          const options = plan.data.map((d) => ({
            value: d.value,
            label: d.label,
            name: "plan",
          }));
          this.setState({ array_plan: options });
        });
    } else if (localStorage.getItem("typestudent") === "4") {
      this.setState({ level: "5" });
      this.setState({ level2: "6" });
      let headers = new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      });
      axios
        .post(
          mua + "/admission/plan/",
          { level: "5" },
          { headers: headers }
        )
        .then((plan) => {
          const options = plan.data.map((d) => ({
            value: d.value,
            label: d.label,
            name: "plan",
          }));
          this.setState({ array_plan: options });
        });
      axios
        .post(
          mua + "/admission/plan/",
          { level: "6" },
          { headers: headers }
        )
        .then((plan) => {
          const options2 = plan.data.map((d) => ({
            value: d.value,
            label: d.label,
            name: "plan2",
          }));
          this.setState({ array_plan2: options2 });
        });
    } else {
      if (localStorage.getItem("level")) {
        // if (localStorage.getItem("robId") !== "132") {
        if (localStorage.getItem("robId") !== "140") {
          // if (localStorage.getItem("robId") !== "117") {
          this.setState({ level: localStorage.getItem("level") });
          this.setState({ plan: localStorage.getItem("plan") });
          this.setState({ vga: localStorage.getItem("vga") });

          let headers = new Headers({
            "Content-Type": "application/x-www-form-urlencoded",
          });
          axios
            .post(
              mua + "/admission/plan/",
              { level: localStorage.getItem("level") },
              { headers: headers }
            )
            .then((plan) => {
              const options2 = plan.data.map((d) => ({
                value: d.value,
                label: d.label,
                name: "plan",
              }));
              this.setState({ array_plan: options2 });
            });
        } else {
          this.setState({ level: "3" });
          const options2 = [
            { value: "69", label: "English Program", name: "plan" },
            { value: "61", label: "คณิตศาสตร์-คอมพิวเตอร์", name: "plan" },
            { value: "394", label: "คณิตศาสตร์-อังกฤษ", name: "plan" },
            { value: "73", label: "ดนตรี-ศิลปะ", name: "plan" },
            {
              value: "222",
              label: "นิติศาสตร์-รัฐประศาสนศาสตร์",
              name: "plan",
            },
            { value: "64", label: "บริหารธุรกิจ", name: "plan" },
            { value: "62", label: "บัญชี-คอมพิวเตอร์ธุรกิจ", name: "plan" },
            { value: "224", label: "พณิชยกรรม", name: "plan" },
            { value: "396", label: "ภาษา-สังคม", name: "plan" },
            { value: "400", label: "ภาษาอังกฤษ-สังคม", name: "plan" },
            { value: "1", label: "วิทยาศาสตร์-คณิตศาสตร์", name: "plan" },
            { value: "58", label: "ศิลป์ - คำนวณ", name: "plan" },
            { value: "514", label: "ศิลป์ - สังคม", name: "plan" },
            { value: "393", label: "ศิลป์-คอมพิวเตอร์", name: "plan" },
            { value: "215", label: "ศิลป์-ดนตรี", name: "plan" },
            { value: "2", label: "ศิลป์-ทั่วไป", name: "plan" },
            { value: "510", label: "ศิลป์นิติศาสตร์-รัฐศาสตร์", name: "plan" },
            { value: "59", label: "ศิลป์-ภาษา", name: "plan" },
            { value: "70", label: "ศิลป์-ภาษาจีน", name: "plan" },
            { value: "71", label: "ศิลป์-ภาษาอังกฤษ", name: "plan" },
            { value: "213", label: "ศิลป์-สังคม", name: "plan" },
            { value: "68", label: "ศิลป์-เสรี", name: "plan" },
            { value: "216", label: "ศิลปะ", name: "plan" },
            { value: "395", label: "อังกฤษ จีน", name: "plan" },
          ];
          this.setState({ array_plan: options2 });
        }
      } else {
        // if (localStorage.getItem("robId") === "132") {
        if (localStorage.getItem("robId") === "140") {
          // if (localStorage.getItem("robId") === "117") {
          this.setState({ level: "3" });
          const options2 = [
            { value: "69", label: "English Program", name: "plan" },
            { value: "61", label: "คณิตศาสตร์-คอมพิวเตอร์", name: "plan" },
            { value: "394", label: "คณิตศาสตร์-อังกฤษ", name: "plan" },
            { value: "73", label: "ดนตรี-ศิลปะ", name: "plan" },
            {
              value: "222",
              label: "นิติศาสตร์-รัฐประศาสนศาสตร์",
              name: "plan",
            },
            { value: "64", label: "บริหารธุรกิจ", name: "plan" },
            { value: "62", label: "บัญชี-คอมพิวเตอร์ธุรกิจ", name: "plan" },
            { value: "224", label: "พณิชยกรรม", name: "plan" },
            { value: "396", label: "ภาษา-สังคม", name: "plan" },
            { value: "400", label: "ภาษาอังกฤษ-สังคม", name: "plan" },
            { value: "1", label: "วิทยาศาสตร์-คณิตศาสตร์", name: "plan" },
            { value: "58", label: "ศิลป์ - คำนวณ", name: "plan" },
            { value: "514", label: "ศิลป์ - สังคม", name: "plan" },
            { value: "393", label: "ศิลป์-คอมพิวเตอร์", name: "plan" },
            { value: "215", label: "ศิลป์-ดนตรี", name: "plan" },
            { value: "2", label: "ศิลป์-ทั่วไป", name: "plan" },
            { value: "510", label: "ศิลป์นิติศาสตร์-รัฐศาสตร์", name: "plan" },
            { value: "59", label: "ศิลป์-ภาษา", name: "plan" },
            { value: "70", label: "ศิลป์-ภาษาจีน", name: "plan" },
            { value: "71", label: "ศิลป์-ภาษาอังกฤษ", name: "plan" },
            { value: "213", label: "ศิลป์-สังคม", name: "plan" },
            { value: "68", label: "ศิลป์-เสรี", name: "plan" },
            { value: "216", label: "ศิลปะ", name: "plan" },
            { value: "395", label: "อังกฤษ จีน", name: "plan" },
          ];
          this.setState({ array_plan: options2 });
        }
      }
    }
    axios
      .get(mua + "/admission/level/")
      .then((level) => {
        const options = level.data.map((d) => ({
          value: d.LEVEL_EDU_ID,
          label: d.LEVEL_EDU_NAME,
        }));
        this.setState({ array_level: options });
      });
  }

  handleLevelChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ plan: "" });
    this.setState({ vga: "" });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        mua + "/admission/plan/",
        { level: event.target.value },
        { headers: headers }
      )
      .then((plan) => {
        const options2 = plan.data.map((d) => ({
          value: d.value,
          label: d.label,
          name: "plan",
        }));
        this.setState({ array_plan: options2 });
      });
  }

  handlePlanChange(event) {
    if (event.name === "plan" || event.name === "plan2") {
      this.setState({ [event.name]: event.value });
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  }

  handleVgaChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    localStorage.setItem("level", this.state.level);
    localStorage.setItem("plan", this.state.plan);
    localStorage.setItem("vga", this.state.vga);
    localStorage.setItem("level2", this.state.level2);
    localStorage.setItem("plan2", this.state.plan2);
    localStorage.setItem("vga2", this.state.vga2);
    if (isNurseRound(localStorage.getItem("robId"))) {
    // if (localStorage.getItem("robId") === "159") {
      var checkvga = this.state.vga + "00";
      checkvga = checkvga.replace(".", "");
      checkvga = checkvga.substring(0, 3);
      if (checkvga >= 250 && this.state.level === "3") {
        localStorage.setItem("faculty", "8");
        localStorage.setItem("majorid", "9902");
        localStorage.setItem("typestd", "1");
        window.location.href = `${process.env.REACT_APP_BASENAME || ""}/FormRegistNurse`;
        // window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formprofile`;
        // window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formregisters`;
      } else {
        Swal.fire(
          "สมัครไม่สำเร็จ",
          "ไม่สามารถสมัครหลักสูตรพยาบาลศาสตรบัณฑิตได้ เนื่องจากคุณสมบัติของท่านไม่ผ่านเกณฑ์",
          "error"
        );
      }
    } else {
      if (localStorage.getItem("typestudent") === "1" ) {
        window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formregisters`;
      } else {
        window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formregister`;
      }
    }
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลวุฒิการศึกษา มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข้อมูลวุฒิการศึกษา มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta
            property="og:title"
            content="ข้อมูลวุฒิการศึกษา มหาวิทยาลัยราชภัฏกำแพงเพชร"
          />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          {localStorage.getItem("typestudent") === "1" ? (
            <>
              <h4>
                {isNurseRound(localStorage.getItem("robId"))
                  ? "สมัครเรียนหลักสูตรพยาบาลศาสตรบัณฑิต มหาวิทยาลัยราชภัฏกำแพงเพชร"
                  : "สมัครเรียนปริญญาตรีภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร"}
              </h4>
            </>
          ) : (
            <>
              {localStorage.getItem("typestudent") === "2" ? (
                <>
                  <h4>
                    สมัครเรียนปริญญาตรีภาคกศ.บป. (เสาร์-อาทิตย์)
                    มหาวิทยาลัยราชภัฏกำแพงเพชร
                  </h4>
                </>
              ) : (
                <>
                  {localStorage.getItem("typestudent") === "3" ? (
                    <>
                      <h4>สมัครเรียนปริญญาโท มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
                    </>
                  ) : (
                    <>
                      {localStorage.getItem("typestudent") === "4" ? (
                        <>
                          <h4>
                            สมัครเรียนปริญญาเอก มหาวิทยาลัยราชภัฏกำแพงเพชร
                          </h4>
                        </>
                      ) : (
                        <>
                          {localStorage.getItem("typestudent") === "5" ? (
                            <>
                              <h4>
                                สมัครเรียนประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู
                                มหาวิทยาลัยราชภัฏกำแพงเพชร
                              </h4>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
          <form onSubmit={this.handleSubmit}>
            <MDBRow>
              <MDBCol lg="1" md="1" sm="1"></MDBCol>
              <MDBCol lg="10" md="10" sm="10">
                <MDBCard>
                  <MDBCardBody>
                    <MDBContainer fluid>
                      <MDBRow>
                        <MDBCol>
                          <MDBCardTitle>วุฒิการศึกษา &nbsp;{" "}
                          <Text className="text-danger">* หากไม่พบข้อมูล โทร. 055-706547</Text></MDBCardTitle>
                          <MDBCardText>
                            {localStorage.getItem("typestudent") === "3" ||
                            localStorage.getItem("typestudent") === "4" ? (
                              <>
                                <MDBRow>
                                  <MDBCol
                                    className="mt-2"
                                    lg="6"
                                    md="12"
                                    sm="12"
                                  >
                                    <h5 className="black-text">
                                      วุฒิปริญญาตรี
                                    </h5>
                                    <div className="form-outline">
                                      <label className="form-label" for="level">
                                        วุฒิการศึกษาที่สำเร็จการศึกษา
                                      </label>
                                      <select
                                        class="form-control"
                                        id="level"
                                        name="level"
                                        value={this.state.level}
                                        onChange={this.handleLevelChange}
                                        disabled={true}
                                        required
                                      >
                                        <option value="" hidden>
                                          ---วุฒิการศึกษาที่สำเร็จการศึกษา---
                                        </option>
                                        {this.state.array_level.map((data) => {
                                          return data.value ===
                                            this.state.level ? (
                                            <>
                                              <option
                                                value={data.value}
                                                selected
                                              >
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>
                                                {data.label}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>

                                    <div class="form-outline">
                                      <label className="form-label" for="plan">
                                        แผนการเรียน
                                      </label>
                                      <Select
                                        className="basic-single"
                                        isSearchable={true}
                                        id="plan"
                                        name="plan"
                                        options={this.state.array_plan}
                                        onChange={this.handlePlanChange}
                                        placeholder="---ระบุแผนการเรียน---"
                                      />
                                    </div>

                                    <div class="form-outline">
                                      <label className="form-label" for="vga">
                                        ผลการเรียนเฉลี่ย
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="vga"
                                        name="vga"
                                        maxlength="4"
                                        value={this.state.vga}
                                        data-mdb-input-mask=".00"
                                        onChange={this.handleVgaChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  {localStorage.getItem("typestudent") ===
                                  "4" ? (
                                    <>
                                      <MDBCol
                                        className="mt-2"
                                        lg="6"
                                        md="12"
                                        sm="12"
                                      >
                                        <h5 className="black-text">
                                          วุฒิปริญญาโท
                                        </h5>
                                        <div className="form-outline">
                                          <label
                                            className="form-label"
                                            for="level2"
                                          >
                                            วุฒิการศึกษาที่สำเร็จการศึกษา
                                          </label>
                                          <select
                                            class="form-control"
                                            id="level2"
                                            name="level2"
                                            value={this.state.level2}
                                            onChange={this.handleLevelChange}
                                            disabled={true}
                                            required
                                          >
                                            <option value="" hidden>
                                              ---วุฒิการศึกษาที่สำเร็จการศึกษา---
                                            </option>
                                            {this.state.array_level.map(
                                              (data) => {
                                                return data.value ===
                                                  this.state.level2 ? (
                                                  <>
                                                    <option
                                                      value={data.value}
                                                      selected
                                                    >
                                                      {data.label}
                                                    </option>
                                                  </>
                                                ) : (
                                                  <>
                                                    <option value={data.value}>
                                                      {data.label}
                                                    </option>
                                                  </>
                                                );
                                              }
                                            )}
                                          </select>
                                        </div>

                                        <div class="form-outline">
                                          <label
                                            className="form-label"
                                            for="plan2"
                                          >
                                            แผนการเรียน
                                          </label>
                                          <Select
                                            className="basic-single"
                                            isSearchable={true}
                                            id="plan2"
                                            name="plan2"
                                            options={this.state.array_plan2}
                                            onChange={this.handlePlanChange}
                                            placeholder="---ระบุแผนการเรียน---"
                                          />
                                        </div>

                                        <div class="form-outline">
                                          <label
                                            className="form-label"
                                            for="vga2"
                                          >
                                            ผลการเรียนเฉลี่ย
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="vga2"
                                            name="vga2"
                                            maxlength="4"
                                            value={this.state.vga2}
                                            data-mdb-input-mask=".00"
                                            onChange={this.handleVgaChange}
                                            required
                                          />
                                        </div>
                                      </MDBCol>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </MDBRow>

                                {this.state.level !== "" &&
                                this.state.plan !== "" &&
                                this.state.vga !== "" ? (
                                  <>
                                    <button
                                      type="submit"
                                      className="btn btn-info btn-rounded btn-md"
                                    >
                                      บันทึก
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      type="submit"
                                      className="btn btn-info btn-rounded btn-md"
                                      disabled
                                    >
                                      บันทึก
                                    </button>
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                <div className="form-outline">
                                  <label className="form-label" for="level">
                                    วุฒิการศึกษาที่สำเร็จการศึกษา
                                  </label>
                                  <select
                                    class="form-control"
                                    id="level"
                                    name="level"
                                    value={this.state.level}
                                    onChange={this.handleLevelChange}
                                    disabled={
                                      // localStorage.getItem("robId") === "132"
                                      localStorage.getItem("robId") === "140"
                                        ? //   localStorage.getItem("robId") === "117" พยาบาล
                                          true
                                        : false
                                    }
                                    required
                                  >
                                    <option value="" hidden>
                                      ---ระบุวุฒิการศึกษาที่สำเร็จการศึกษา---
                                    </option>
                                    {this.state.array_level.map((data) => {
                                      return data.value === this.state.level ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>
                                            {data.label}
                                          </option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>

                                <div class="form-outline">
                                  <label className="form-label" for="plan">
                                    แผนการเรียน
                                  </label>
                                  {localStorage.getItem("level") ? (
                                    <>
                                      <select
                                        class="form-control"
                                        id="plan"
                                        name="plan"
                                        value={this.state.plan}
                                        onChange={this.handlePlanChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ---ระบุแผนการเรียน---
                                        </option>
                                        {this.state.array_plan.map((data) => {
                                          return data.value ===
                                            this.state.plan ? (
                                            <>
                                              <option
                                                value={data.value}
                                                selected
                                              >
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>
                                                {data.label}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </>
                                  ) : (
                                    <>
                                      <Select
                                        className="basic-single"
                                        isSearchable={true}
                                        id="plan"
                                        name="plan"
                                        options={this.state.array_plan}
                                        onChange={this.handlePlanChange}
                                        placeholder="เลือกแผนการเรียน"
                                      />
                                    </>
                                  )}
                                </div>

                                <div class="form-outline">
                                  <label className="form-label" for="vga">
                                    ผลการเรียนเฉลี่ย
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="vga"
                                    name="vga"
                                    placeholder="ผลการเรียนเฉลี่ย"
                                    maxlength="4"
                                    value={this.state.vga}
                                    data-mdb-input-mask=".00"
                                    onChange={this.handleVgaChange}
                                    required
                                  />
                                </div>

                                {this.state.level !== "" &&
                                this.state.plan !== "" &&
                                this.state.vga !== "" ? (
                                  <>
                                    <button
                                      type="submit"
                                      className="btn btn-info btn-rounded btn-md"
                                    >
                                      บันทึก
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      type="submit"
                                      className="btn btn-info btn-rounded btn-md"
                                      disabled
                                    >
                                      บันทึก
                                    </button>
                                  </>
                                )}
                              </>
                            )}
                          </MDBCardText>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol lg="1" md="1" sm="1"></MDBCol>
            </MDBRow>
          </form>
        </MDBContainer>
      </>
    );
  }
}


